import { render, staticRenderFns } from "./AssetNew.vue?vue&type=template&id=2a4f14e4&scoped=true&"
import script from "./AssetNew.vue?vue&type=script&lang=js&"
export * from "./AssetNew.vue?vue&type=script&lang=js&"
import style0 from "./AssetNew.vue?vue&type=style&index=0&id=2a4f14e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4f14e4",
  null
  
)

export default component.exports